
/**
 * @export
 * @enum {string}
 */
export enum AiTokenLimitPeriod {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY'
}